export default __webpack_public_path__ + "static/request-dialog-740e498506ba7830b6582e12eb78d8ae.png";